import Keen from 'keen-js'
import config from '../config'
import { getCurrentUser } from './sessionStorage'

var client = new Keen({
  projectId: config.keen.tracking.projectId,
  writeKey: config.keen.tracking.writeKey
})

export function createClient () {
  return client
}

export function saveKeenEvent (collection, payload) {
  let event = {
    user_agent: '${keen.user_agent}', // eslint-disable-line
    ip_address: '${keen.ip}', // eslint-disable-line
    page_url: window.location.href,
    keen: {
      timestamp: new Date().toISOString(),
      addons: [
        {
          name: 'keen:ua_parser',
          input: {
            ua_string: 'user_agent'
          },
          output: 'parsed_user_agent'
        },
        {
          name: 'keen:ip_to_geo',
          input: {
            ip: 'ip_address'
          },
          output: 'ip_geo_info'
        },
        {
          name: 'keen:date_time_parser',
          input: {
            date_time: 'keen.timestamp'
          },
          output: 'timestamp_info'
        },
        {
          name: 'keen:url_parser',
          input: {
            url: 'page_url'
          },
          output: 'parsed_page_url'
        }
      ]
    }
  }
  let user = getCurrentUser()
  if (user) event['user'] = user
  if (payload) {
    event = {
      ...event,
      ...payload
    }
  }

  client.addEvent(collection, event, (err, res) => {
    if (err) {
      console.log(`Error adding event ${collection} to Keen.`)
    }
  })
}



// WEBPACK FOOTER //
// ./src/utils/KeenTracking.js